import { inject, Injectable } from '@angular/core';
import { forkJoin, Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { ClientInvoice, CustomHttpResponse, HydraCollectionResponse, SupplierInvoice } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SupplierInvoiceService {
  apiService: ApiHttpService<SupplierInvoice> = inject(ApiHttpService<SupplierInvoice>);

  get(iri: string): Observable<SupplierInvoice> {
    return this.apiService.get(iri).pipe(
      take(1),
      map((result: CustomHttpResponse<SupplierInvoice>) => result.body),
    );
  }

  getForIris(iris: string[]): Observable<SupplierInvoice[]> {
    const requests = iris.map((iri) =>
      this.apiService.get(iri).pipe(
        take(1),
        map((result: CustomHttpResponse<SupplierInvoice>) => result.body)
      )
    );

    return forkJoin(requests);
  }

  getSupplierInvoices(): Observable<SupplierInvoice[]> {
    return this.apiService.getMany(`/supplier_invoices`).pipe(map((result) => result.body['hydra:member']));
  }

  patch(iri: string, update: SupplierInvoice): Observable<SupplierInvoice> {
    return this.apiService.patch(iri, update).pipe(map((result: CustomHttpResponse<SupplierInvoice>) => result.body));
  }

  delete(entity: SupplierInvoice) {
    return this.apiService.delete(`${entity['@id']}`).pipe(map((result) => result));
  }

  getSupplierInvoicesByFilter(filters: string[]): Observable<SupplierInvoice[]> {
    const url = filters && filters.length ? `/supplier_invoices?${filters.join('&')}` : `/supplier_invoices`;
    return this.apiService
      .getMany(url)
      .pipe(map((result: CustomHttpResponse<HydraCollectionResponse<SupplierInvoice>>) => result.body['hydra:member']));
  }
}
